import React, { useEffect, useState } from 'react';
import dayjs from "dayjs";
export const CarePlanDemographicSection = (props) => {
    const [mrn, setMrn] = useState('');
    const [primaryDiagnosis, setPrimaryDiagnosis] = useState('');
    const [secondaryDiagnosis, setSecondaryDiagnosis] = useState(null);
    const [providerName, setProviderName] = useState('');
    useEffect(() => {
        setMrn(props.demographics?.mrn);
        setPrimaryDiagnosis(props.demographics?.primaryDiagnosis);
        setSecondaryDiagnosis(props.demographics?.secondaryDiagnosis);
        setProviderName(props.demographics?.providerName);
    }, [props.demographics]);
    return (React.createElement("div", { style: { width: '100%', height: '100%', padding: 16, background: 'white', borderRadius: 6, outline: '1px var(--elevation-outlined, #E0E0E0) solid', outlineOffset: '-1px', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', gap: 7, display: 'inline-flex' } },
        React.createElement("div", { style: { color: 'black', fontSize: 20, fontFamily: 'Barlow', fontWeight: '600' } },
            props.patient.personalInfo.firstname,
            " ",
            props.patient.personalInfo.lastname),
        React.createElement("div", { style: { color: 'black', fontSize: 14, fontFamily: 'Barlow', fontWeight: '500' } },
            "DOB: ",
            dayjs(props.patient.dob).format('MM/DD/YYYY'),
            " | Act #: ",
            mrn,
            " | Diagnoses: ",
            primaryDiagnosis,
            secondaryDiagnosis && `, ${secondaryDiagnosis}`,
            " | Provider: ",
            providerName),
        React.createElement("div", { style: { textAlign: 'right', justifyContent: 'center', display: 'flex', flexDirection: 'column', color: 'var(--text-secondary, rgba(0, 0, 0, 0.60))', fontSize: 14, fontFamily: 'Barlow', fontWeight: '500' } }, props.carePlanFirstEdit !== '' && `Date Care Plan Developed: ${props.carePlanFirstEdit}`)));
};
